module.exports = __webpack_public_path__ + "img/headLogoW.5228f668.png";